import ActionMenu from "./ActionMenu"
import ActionMenuConfirmItem from "./ActionMenuConfirmItem"
import ActionMenuContent from "./ActionMenuContent"
import ActionMenuItem from "./ActionMenuItem"
import ActionMenuLinkItem from "./ActionMenuLinkItem"
import ActionMenuLabel from "./ActionMenuLabel"
import ActionMenuSeparator from "./ActionMenuSeparator"
import ActionMenuTrigger from "./ActionMenuTrigger"

export type { ActionMenuProps } from "./ActionMenu"
export type { ActionMenuConfirmItemProps } from "./ActionMenuConfirmItem"
export type { ActionMenuContentProps } from "./ActionMenuContent"
export type {
  ActionMenuItemProps,
  ActionMenuItemVariant,
} from "./ActionMenuItem"
export type { ActionMenuLinkItemProps } from "./ActionMenuLinkItem"
export type { ActionMenuLabelProps } from "./ActionMenuLabel"
export type { ActionMenuSeparatorProps } from "./ActionMenuSeparator"
export type { ActionMenuTriggerProps } from "./ActionMenuTrigger"

export default Object.assign(ActionMenu, {
  Trigger: ActionMenuTrigger,
  Content: ActionMenuContent,
  Item: ActionMenuItem,
  LinkItem: ActionMenuLinkItem,
  ConfirmItem: ActionMenuConfirmItem,
  Label: ActionMenuLabel,
  Separator: ActionMenuSeparator,
})
